export default __webpack_public_path__ + "assets/images/9a2abb5266df9755e431a8c3b701d40b.png";